import { forwardRef, useImperativeHandle } from 'react';
import dynamic from 'next/dynamic';
import useLazy from '@/hooks/useLazy';

const ExplorerFilterModal = dynamic(() => import('./filter'), { ssr: false });

const SortFilter = forwardRef((props: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();

  useImperativeHandle(ref, () => ({
    show: show
  }));

  if (!loaded) return null;
  return <ExplorerFilterModal {...props} modalShow={visible} onCancel={hide} />;
});

export default SortFilter;
